import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "legend", "menu", "option", "trigger"]

  initialize() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  connect() {
    window.addEventListener("click", this.closeOnClickOutside)
    window.addEventListener("keydown", this.closeOnEscape)
    this.resizeFrame = requestAnimationFrame(() => this.setMinimumWidth())
  }

  disconnect() {
    window.removeEventListener("click", this.closeOnClickOutside)
    window.removeEventListener("keydown", this.closeOnEscape)
    cancelAnimationFrame(this.resizeFrame)
    this.close()
  }

  toggle() {
    this.element.classList.contains("active") ? this.close() : this.open()
  }

  open() {
    this.closeOtherDropdowns()
    this.element.classList.add("active")
    this.menuTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")
    document.body.classList.add("dropdown-opened")
  }

  close() {
    this.element.classList.remove("active")
    this.menuTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
    document.body.classList.toggle("dropdown-opened", this.hasOpenDropdown)
  }

  select(event) {
    event.preventDefault()
    const option = event.currentTarget
    this.inputTarget.value = option.dataset.value || ""
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.close()
    this.triggerTarget.focus()
  }

  syncFromInput() {
    const option = this.optionTargets.find(candidate => (candidate.dataset.value || "") === this.inputTarget.value)
    this.triggerTarget.textContent = option?.dataset.text || ""
    this.optionTargets.forEach(candidate => {
      const selected = candidate === option
      candidate.classList.toggle("active", selected)
      candidate.setAttribute("aria-selected", selected.toString())
    })
    if (this.hasLegendTarget) this.legendTarget.classList.toggle("active", this.inputTarget.value.length > 0)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.element.classList.contains("active")) return

    this.close()
    this.triggerTarget.focus()
  }

  closeOtherDropdowns() {
    document.querySelectorAll('[data-controller~="website--dropdown-select"].active').forEach(dropdown => {
      if (dropdown === this.element) return

      dropdown.classList.remove("active")
      dropdown.querySelector('[data-website--dropdown-select-target="menu"]').hidden = true
      dropdown.querySelector('[data-website--dropdown-select-target="trigger"]').setAttribute("aria-expanded", "false")
    })
  }

  setMinimumWidth() {
    if (!this.hasLegendTarget || this.triggerTarget.offsetWidth >= this.legendTarget.offsetWidth) return

    this.triggerTarget.style.minWidth = `${this.legendTarget.offsetWidth}px`
  }

  get hasOpenDropdown() {
    return Boolean(document.querySelector('[data-controller~="website--dropdown-select"].active'))
  }
}
